module.exports = __webpack_public_path__ + "img/Bottom-right.1bd965db.svg";